<template>
  <AdministrationHeader>
    <AdministrationPanel :load="load" v-slot="{ data }">
      <OverviewStats :data="data" />
    </AdministrationPanel>
  </AdministrationHeader>
</template>

<script>
import AdministrationHeader from "@/administration/components/AdministrationHeader.vue";
import AdministrationPanel from "@/administration/components/AdministrationPanel.vue";
import OverviewStats from "@/administration/components/OverviewStats.vue";
import {AdministrationController} from "@/administration/controllers/AdministrationController";

export default {
  name: 'AdministrationOverviewView',
  components: {AdministrationHeader, AdministrationPanel, OverviewStats},
  methods: {
    load: () => AdministrationController.getOverview(),
  },
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color THEME_COLOR_PRIMARY
  span
    color THEME_COLOR_PRIMARY_FADDED
</style>
